import get from '../helpers/get';
import { CONTENT_FULFILLED } from '../actions';
import mergeSliceState from '../helpers/mergeSliceState';

const mergeItemSetState = (state, nextState, { itemSetNamePlural, sliceId }) => ({
  ...state,
  [itemSetNamePlural]: mergeSliceState(state[itemSetNamePlural], sliceId, nextState),
});

const handleFulfilled = (state, action, {
  itemSetIdName,
  itemSetNamePlural,
  itemTypePlural,
  itemIdName,
}) => ({
  ...mergeItemSetState(state, {
    busy: false,
    error: undefined,
    page: action.payload.meta.page,
    totalCount: action.payload.meta.totalCount,
    [itemTypePlural]: action.meta.overwriteItemSetItems
      ? action.payload[itemTypePlural].map(item => item[itemIdName])
      : [
        ...(get(state, [itemSetNamePlural, action.meta[itemSetIdName], itemTypePlural]) || []),
        ...action.payload[itemTypePlural].map(item => item[itemIdName]),
      ],
  }, { sliceId: action.meta[itemSetIdName], itemSetNamePlural }),
  [itemTypePlural]: {
    ...get(state, [itemTypePlural]),
    ...action.payload[itemTypePlural].reduce((keyedById, item) => ({
      ...keyedById,
      [item[itemIdName]]: item,
    }), {}),
  },
});

export const createItemSetsFromSliceContentGetter = ({
  sliceTypes,
  filterKeys,
  sanitizeFilterValue = filter => filter || undefined,
}) => sliceContent => {
  if (sliceTypes.indexOf(sliceContent.type) >= 0) {
    return {
      [sliceContent.sliceId]: {
        filters: filterKeys.reduce((prevFilters, filterKey) => {
          const filterValue = sanitizeFilterValue(sliceContent[`filter_${filterKey}`], filterKey);
          if (filterValue !== undefined) {
            return {
              ...prevFilters,
              [filterKey]: filterValue,
            };
          }
          return prevFilters;
        }, {}),
      },
    };
  }
  return undefined;
};

export const createItemSetsFromSlicesGetter = ({
  getItemSetsFromSliceContent,
  itemSetNamePlural = 'slices',
}) => (prevState, content) => ({
  ...prevState,
  [itemSetNamePlural]: (content.body || []).reduce((nextSlices, sliceContent) => {
    const itemSets = getItemSetsFromSliceContent(sliceContent);
    if (itemSets) {
      return {
        ...nextSlices,
        ...itemSets,
      };
    }
    return nextSlices;
  }, { ...prevState[itemSetNamePlural] }),
});

export default ({
  actionType,
  getItemSetsFromSlices,
  initialState,
  itemSetIdName = 'sliceId',
  itemSetNamePlural = 'slices',
  itemTypePlural,
  itemIdName,
}) => (state = initialState, action) => {
  switch (action.type) {
    case CONTENT_FULFILLED:
      return getItemSetsFromSlices(state, action.payload);
    case `${actionType}_PENDING`:
      return mergeItemSetState(state, {
        busy: true,
      }, { sliceId: action.meta[itemSetIdName], itemSetNamePlural });
    case `${actionType}_FULFILLED`:
      return handleFulfilled(state, action, {
        itemSetIdName,
        itemSetNamePlural,
        itemTypePlural,
        itemIdName,
      });
    case `${actionType}_REJECTED`:
      return mergeItemSetState(state, {
        busy: false,
        error: action.payload,
      }, { sliceId: action.meta[itemSetIdName], itemSetNamePlural });
    default:
      return state;
  }
};
